import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const BDashboard = ({product}) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        product == 'Salon Software' ?
        'https://api.dectwincam.com/sapi/get-all-users'
        :
        'https://api.dectwincam.com/dapi/get-all-users'
      );

      if (response.ok) {
        const data = await response.json();
        setUsers(data);
      } else {
        console.error('Failed to fetch users');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }

    setLoading(false);
  };

  // ==========================
  // Dashboard Calculations
  // ==========================

  const now = new Date();

  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  const nextMonthDate = new Date(
    currentYear,
    currentMonth + 1,
    1
  );

  const nextMonth = nextMonthDate.getMonth();
  const nextMonthYear = nextMonthDate.getFullYear();

  // Current Month Expiring
  const currentMonthExpiring = users.filter((user) => {
    if (!user.end_date) return false;

    const endDate = new Date(user.end_date);

    return (
      endDate.getMonth() === currentMonth &&
      endDate.getFullYear() === currentYear
    );
  });

  // Upcoming Month Expiring
  const upcomingMonthExpiring = users.filter((user) => {
    if (!user.end_date) return false;

    const endDate = new Date(user.end_date);

    return (
      endDate.getMonth() === nextMonth &&
      endDate.getFullYear() === nextMonthYear
    );
  });

  // Current Month Purchases
  const currentMonthPurchases = users.filter((user) => {
    if (!user.start_date) return false;

    const startDate = new Date(user.start_date);

    return (
      startDate.getMonth() === currentMonth &&
      startDate.getFullYear() === currentYear
    );
  });


const currentMonthPlayStore = users.filter((user) => {
  if (!user.start_date || user.source != "Play Store") return false;

  const date = new Date(user.start_date);

  return (
    date.getMonth() === currentMonth &&
    date.getFullYear() === currentYear
  );
});

const currentMonthMicrosoftStore = users.filter((user) => {
  if (!user.start_date || user.source != "Microsoft Store") return false;

  const date = new Date(user.start_date);

  return (
    date.getMonth() === currentMonth &&
    date.getFullYear() === currentYear
  );
});

const currentMonthSelf = users.filter((user) => {
  if (!user.start_date || user.source != "Self") return false;

  const date = new Date(user.start_date);

  return (
    date.getMonth() === currentMonth &&
    date.getFullYear() === currentYear
  );
});

const sourceStats = users.reduce(
  (acc, user) => {
    if (user.source === 'Play Store') {
      acc.playStore++;
    } else if (user.source === 'Microsoft Store') {
      acc.microsoftStore++;
    } else {
      acc.self++;
    }

    return acc;
  },
  {
    playStore: 0,
    microsoftStore: 0,
    self: 0
  }
);

  const dashboardCards = [
    {
      title: 'Total Users',
      value: users.length,
      icon: 'fa-solid fa-users',
      className: 'dashboard-primary',
      textClass: 'text-dashboard-primary',
      circleClass: 'circle-primary',
    },
        {
  title: 'Self Installation',
  value: sourceStats.self,
  icon: 'fa-solid fa-spa',
  className: 'bg-info',
  textClass: 'text-light',
  circleClass: 'circle-light',
},
    {
  title: 'Microsoft Store Downloads',
  value: sourceStats.microsoftStore,
  icon: 'fa-solid fa-store',
  className: 'bg-light',
  textClass: 'text-info',
  circleClass: 'circle-info',
},
    {
  title: 'Play Store Downloads',
  value: sourceStats.playStore,
  icon: 'fa-brands fa-google-play',
  className: 'dashboard-warning',
  textClass: 'text-warning',
  circleClass: 'circle-warning',
},


    {
      title: 'Current Month Expiring',
      value: currentMonthExpiring.length,
      icon: 'fa-solid fa-calendar-xmark',
      className: 'dashboard-danger',
      textClass: 'text-dashboard-danger',
      circleClass: 'circle-danger',
    },
    {
      title: 'Upcoming Month Expiring',
      value: upcomingMonthExpiring.length,
      icon: 'fa-solid fa-clock',
      className: 'dashboard-warning',
      textClass: 'text-dashboard-warning',
      circleClass: 'circle-warning',
    },
    {
      title: 'Current Month Purchases',
      value: currentMonthPurchases.length,
      icon: 'fa-solid fa-cart-shopping',
      className: 'dashboard-success',
      textClass: 'text-dashboard-success',
      circleClass: 'circle-success',
    },
  ];

  return (
    <section className='containerfluid py-3'>
      {/* Header */}

      <div className='dashboard-header mb-4'>
        <div>
          <h2 className='dashboard-title'>
            Dashboard Overview
          </h2>

          <p className='dashboard-subtitle'>
            Welcome back, Admin 👋
          </p>
        </div>

        <button
          className='btn btn-dark rounded-pill px-4'
          onClick={fetchUsers}
        >
          Refresh
        </button>
      </div>

      {/* Loading */}

      {loading ? (
        <div className='text-center py-5'>
          <div className='spinner-border text-primary'></div>
        </div>
      ) : (
        <>
          {/* Cards */}

          <div className='row g-3'>
            {dashboardCards.map((card, index) => (
              <div className='col-xl-3 col-md-6 ' key={index}>
                <div
                  className={`dashboard-card shadow-sm ${card.className}`}
                >
                  <div className='d-flex justify-content-between align-items-start'>
                    <div>
                      <p
                        className={`dashboard-card-title ${card.textClass}`}
                      >
                        {card.title}
                      </p>

                      <h1
                        className={`dashboard-card-value ${card.textClass}`}
                      >
                        {card.value}
                      </h1>
                    </div>

                    <div
                      className={`dashboard-icon-wrapper ${card.circleClass}`}
                    >
                      <i
                        className={`${card.icon} dashboard-icon ${card.textClass}`}
                      ></i>
                    </div>
                  </div>

                  <div
                    className={`dashboard-circle ${card.circleClass}`}
                  ></div>
                </div>
              </div>
            ))}
          </div>

          {/* Panels */}

          <div className='row mt-3'>
            {/* Expiring */}

            <div className='col-lg-6 mb-3'>
              <div className='dashboard-panel'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h5 className='dashboard-panel-title text-danger'>
                    Expiring This Month
                  </h5>

                  <span className='badge bg-danger'>
                    {currentMonthExpiring.length}
                  </span>
                </div>

                {currentMonthExpiring.length > 0 ? (
                  currentMonthExpiring
                    .slice(0, 5)
                    .map((user) => (
                      <div
                        key={user.id}
                        className='dashboard-user-row'
                      >
                        <div>
                          <p className='fw-semibold mb-0'>
                            {user.business_name}
                          </p>

                          <small className='text-muted'>
                            {user.mobile}
                          </small>
                        </div>

                        <div className='text-end'>
                          <small className='text-danger fw-semibold'>
                            {new Date(
                              user.end_date
                            ).toLocaleDateString('en-IN')}
                          </small>
                        </div>
                      </div>
                    ))
                ) : (
                  <p className='text-muted mb-0'>
                    No expiring users this month.
                  </p>
                )}
              </div>
            </div>

            {/* Purchases */}

            <div className='col-lg-6 mb-3'>
              <div className='dashboard-panel'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h5 className='dashboard-panel-title text-success'>
                    New Purchases
                  </h5>

                  <span className='badge bg-success'>
                    {currentMonthPurchases.length}
                  </span>
                </div>

                {currentMonthPurchases.length > 0 ? (
                  currentMonthPurchases
                    .slice(0, 5)
                    .map((user) => (
                      <div
                        key={user.id}
                        className='dashboard-user-row'
                      >
                        <div>
                          <p className='fw-semibold mb-0'>
                            {user.business_name}
                          </p>

                          <small className='text-muted'>
                            {user.mobile}
                          </small>
                        </div>

                        <div className='text-end'>
                          <small className='text-success fw-semibold'>
                            {new Date(
                              user.start_date
                            ).toLocaleDateString('en-IN')}
                          </small>
                        </div>
                      </div>
                    ))
                ) : (
                  <p className='text-muted mb-0'>
                    No purchases this month.
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default BDashboard;